import identity from 'lodash/identity';
import * as types from '../../actions/actionTypes';
import installationPricing from './installationPricing';
import calculateTaxSuccess from './calculateTaxSuccess';
import calculateTaxFail from './calculateTaxFail';
import windowsContainInvalidConfigurations from './windowsContainInvalidConfigurations';

const actions = {
  [types.INSTALLATION_PRICING]: installationPricing,
  [types.CALCULATE_TAX_SUCCESS]: calculateTaxSuccess,
  [types.CALCULATE_TAX_FAIL]: calculateTaxFail,
  [types.WINDOWS_CONTAIN_INVALID_CONFIGURATIONS]: windowsContainInvalidConfigurations,
};

const initialState = {};

export default (state = initialState, { type, payload }) => (
  (actions[type] || identity)(state, payload)
);
